import MultiSelect from 'components/MultiSelect';
import { ComponentProps, useMemo } from 'react';
import { TaskStatus } from 'types/common';

const taskStatusOptions: Array<{ label: string; value: TaskStatus }> = [
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Blocked', value: 'BLOCKED' },
  { label: 'Overdue', value: 'LATE' },
  { label: 'Failed', value: 'INCOMPLETE' },
  { label: 'Upcoming', value: 'UPCOMING' },
  { label: 'Completed', value: 'COMPLETED' },
  { label: 'Completed with Delay', value: 'COMPLETED_WITH_DELAY' },
  { label: 'Filled', value: 'COMPLETED_PARTIALLY' },
];

interface TaskStatusFilterProps
  extends Partial<ComponentProps<typeof MultiSelect>> {
  enabledValues?: string;
}

const TaskStatusFilter = (props: TaskStatusFilterProps) => {
  const filteredOptions = useMemo(() => {
    const values = props?.enabledValues?.split(',');
    if (values?.length) {
      return taskStatusOptions.filter((option) =>
        values?.includes(option.value),
      );
    }
    return taskStatusOptions;
  }, [props?.enabledValues]);

  return (
    <MultiSelect
      label={props?.label ?? 'Task Status'}
      options={filteredOptions}
      defaultValue={props.defaultValue}
      value={props.value}
      onChange={props.onChange}
      disabled={props.disabled}
      allowClear
    />
  );
};

export default TaskStatusFilter;
